<template>
    <div class="select-class-children">
        <label class="d-lg-none mt-3 mb-2" v-if="!loading && children.length > 0">
            {{ trans('general.child.select_children') }}
        </label>

        <loader :loading="loading"/>

        <custom-select
            type="list"
            custom-class="scrollable"
            v-if="!loading && children.length > 0"
            v-model="selectedChildren"
            :items="children"/>

        <p class="py-5"
           v-if="!loading && children.length === 0"
           v-html="trans('general.child.no_check_in_report')"/>
    </div>
</template>

<script>
    import CustomSelect from "../../../theme/molecules/CustomSelect.vue";
    import Loader from "../atoms/Loader.vue";

    export default {
        name: "SelectClassChildren",
        components: {Loader, CustomSelect},
        props: {
            group: {
                type: Object,
                required: true
            },
            selectedChildrenIds: {
                type: Array,
                required: false
            },
        },
        data() {
            return {
                children: [],
                selectedChildren: this.selectedChildrenIds ?? [],
                loading: false,
            }
        },
        watch: {
            group: function () {
                this.getChildren()
            },
            selectedChildren: function () {
                const childrenIds = this.selectedChildren.map(child => child.value);
                this.$emit('selected-children-ids', childrenIds);
            }
        },
        methods: {
            getChildren() {
                this.loading = true;
                const params = {
                    page: this.pageNum,
                    limit: 100,
                    include: 'image;appearanceStatus',
                    order_by: 'name'
                };

                axios.get(`/classes/${this.group.id}/children`, {params})
                    .then((response) => {
                        const items = response.data.data.filter(val => (val.appearance_status && val.appearance_status.type === 'check_in' && !val.appearance_status.parent_id))
                        this.children = [];
                        this.loading = false;

                        items.forEach((item) => {
                            this.children.push({
                                value: item.id,
                                text: `${item.name} ${item.surname}`,
                                image: item.image?.sizes.sm ?? '/img/avatar.png',
                                color: this.group.color,
                                icon: null,
                                cls: `child-item`,
                                data: item,
                            });
                        });

                        if (this.selectedChildrenIds) { //match selected children IDs with children
                            this.selectedChildren = this.children.filter(child => this.selectedChildrenIds.includes(child.value));
                        }

                        this.$emit('children-count', this.children.length);
                    });
            },

            selectAll(state) {
                if (state) {
                    this.selectedChildren = [...this.children];
                } else {
                    this.selectedChildren = [];
                }
            },
        },
        mounted() {
            this.getChildren();
        }
    }
</script>
